module.exports = __webpack_public_path__ + "img/chinamap_jp.3d5e5e8a.png";